module.exports = __webpack_public_path__ + "static/media/Inventor.78424364.png";